import { Dispatch } from "redux";
import { dealsApi } from "./api";
import { dealsActions } from "./slice";

export const getSpvList = () => (dispatch: Dispatch) => {
  dealsApi.getSpvs().then(({ data }) => {
    dispatch(dealsActions.setSpvs(data.list));
  });
};
